import { useTranslate } from '@festina-life/ui/hooks'
import { FilterCheckbox } from '@festina-life/ui/listsAndTables'
import { Icon } from '@festina-life/ui/structure'

import { PreferencesMenu } from '../../components/pareferencesMenu/PreferencesMenu'
import { useLayoutContext } from '../../context/layoutContext'

export const TemplateViewPreferencesMenu = () => {
  const { preferences, onChangeView } = useLayoutContext()
  const translate = useTranslate()

  return (
    <PreferencesMenu
      trigger={
        <>
          {translate('templateViewer.topBar.optionsPopover.button')}
          <Icon name="ChevronDown" size="sm" />
        </>
      }
      panelClassName="w-sm"
    >
      <div className="flex flex-col gap-y-2">
        <FilterCheckbox
          label={translate('templateViewer.topBar.option.showNative')}
          id="showNative"
          checked={preferences.templates.isShowingNativeView}
          onChange={() =>
            onChangeView({
              ...preferences,
              templates: {
                ...preferences.templates,
                isShowingNativeView: !preferences.templates.isShowingNativeView,
              },
            })
          }
        />
        <FilterCheckbox
          label={translate('templateViewer.topBar.option.useModal')}
          id="useModal"
          checked={!!preferences.common.isUsingModal}
          onChange={() =>
            onChangeView({
              ...preferences,
              common: {
                ...preferences.common,
                isUsingModal: !preferences.common.isUsingModal,
              },
            })
          }
        />
        <FilterCheckbox
          label={translate(
            'templateViewer.topBar.option.showHoverDocumentation',
          )}
          id="showHoverDocumentation"
          checked={!!preferences.common.isShowingDocumentationOnHover}
          onChange={() =>
            onChangeView({
              ...preferences,
              common: {
                ...preferences.common,
                isShowingDocumentationOnHover:
                  !preferences.common.isShowingDocumentationOnHover,
              },
            })
          }
        />
        <FilterCheckbox
          label={translate('templateViewer.topBar.option.showSimplifiedView')}
          id="showSimplifiedView"
          checked={!!preferences.templates.isShowingSimplifiedView}
          onChange={() =>
            onChangeView({
              ...preferences,
              templates: {
                ...preferences.templates,
                isShowingSimplifiedView:
                  !preferences.templates.isShowingSimplifiedView,
              },
            })
          }
        />
        <FilterCheckbox
          label={translate(
            'templateViewer.topBar.option.fplusHoverOnCtrlHover',
          )}
          id="fplusHoverOnCtrlHover"
          checked={preferences.templates.isFPlusHoverWithCtrlHover}
          onChange={() =>
            onChangeView({
              ...preferences,
              templates: {
                ...preferences.templates,
                isFPlusHoverWithCtrlHover:
                  !preferences.templates.isFPlusHoverWithCtrlHover,
              },
            })
          }
        />
        <FilterCheckbox
          label={translate(
            'templateViewer.topBar.option.showNotRelevantFields',
          )}
          id="showNotRelevantFields"
          checked={!!preferences.templates.isShowingNotRelevantFields}
          onChange={() =>
            onChangeView({
              ...preferences,
              templates: {
                ...preferences.templates,
                isShowingNotRelevantFields:
                  !preferences.templates.isShowingNotRelevantFields,
              },
            })
          }
        />
      </div>
    </PreferencesMenu>
  )
}
